import { ProjectType, TrackStage } from "../../../store/models/project";
import { ScheduledProjectStage } from "../../../store/models/scheduledproject";
import { RecordingSessionStages } from "../../../store/models/recordingSession";

export type OrderByType =
  | "created"
  | "title"
  | "-created"
  | "-title"
  | "priority"
  | "-priority";

export type SortByType =
  | "first_choice_datetime"
  | "-first_choice_datetime"
  | "studio_room__room_name"
  | "-studio_room__room_name"
  | "collaborator_username"
  | "-collaborator_username"
  | "project__total_price"
  | "-project__total_price"
  | "priority"
  | "-priority";

/**
 * Query parameter keys for the booking screen.
 * @example ?services=1,2&stages=active,pending
 */
export enum BookingQueryParamKeys {
  Search = "q",
  ProjectId = "project_id",
  BookingId = "booking_id",
  Page = "page",
  OrderBy = "order_by",
  SortBy = "sort_by",
  Services = "services",
  Stages = "stages",
  SessionTab = "session_tab",
  TrackStages = "track_stages",
  User = "User",
  ScheduledProjectId = "scheduled_project_id",
  Studio = "Studio",
  StudioRoom = "StudioRoom",
  SessionStages = "session_stages",
}

export const BookingQueryParamKeysSanitized: Record<
  BookingQueryParamKeys,
  string
> = {
  [BookingQueryParamKeys.ProjectId]: "Project ID",
  [BookingQueryParamKeys.BookingId]: "Booking ID",
  [BookingQueryParamKeys.Stages]: "Stages",
  [BookingQueryParamKeys.SessionTab]: "Tab",
  [BookingQueryParamKeys.Search]: "Search",
  [BookingQueryParamKeys.Page]: "Page",
  [BookingQueryParamKeys.SortBy]: "Sort",
  [BookingQueryParamKeys.OrderBy]: "Order",
  [BookingQueryParamKeys.Services]: "Services",
  [BookingQueryParamKeys.TrackStages]: "Track Stages",
  [BookingQueryParamKeys.User]: "User",
  [BookingQueryParamKeys.ScheduledProjectId]: "Project ID",
  [BookingQueryParamKeys.Studio]: "Studio",
  [BookingQueryParamKeys.StudioRoom]: "Studio Room",
  [BookingQueryParamKeys.SessionStages]: "Session",
};

export enum SessionTabs {
  Calendar = "calendar",
  Link = "link",
}

export enum BookingTabs {
  NotSet = -1,
  Projects = "projects",
  Sessions = "sessions",
  Links = "links",
}

export const TRACK_STAGES: Record<TrackStage, string> = {
  [TrackStage.ALL]: "All",
  [TrackStage.FILE_TRANSFER]: "File Transfer",
  [TrackStage.IN_REVIEW]: "In Review",
  [TrackStage.IN_PROGRESS]: "In-progress",
  [TrackStage.REVISION_IN_PROGRESS]: "Revision in-progress",
  [TrackStage.FINAL_FILE_TRANSFER]: "Final file transfer",
  [TrackStage.REFUNDED]: "Refunded",
  [TrackStage.COMPLETED]: "Completed",
};

/**
 * Human readable values for various query parameters.
 */
export const SERVICES: Record<ProjectType, string> = {
  [ProjectType.NO_TYPE]: "No Type",
  [ProjectType.RECORDING]: "Recording",
  [ProjectType.MIXING]: "Mixing",
  [ProjectType.MASTERING]: "Mastering",
  [ProjectType.TWO_TRACK_MIXING]: "Mixing (2-track)",
  [ProjectType.ATMOS_MIXING]: "Dolby Atmos",
};

export const SCHEDULED_PROJECT_STAGES: Record<ScheduledProjectStage, string> = {
  [ScheduledProjectStage.ALL]: "All",
  [ScheduledProjectStage.ACTIVE]: "Active",
  [ScheduledProjectStage.COMPLETED]: "Completed",
  [ScheduledProjectStage.PENDING]: "Pending",
  [ScheduledProjectStage.REFUNDED]: "Refunded",
};

export const RECORDING_SESSION_STAGES: Record<RecordingSessionStages, string> =
  {
    [RecordingSessionStages.ALL]: "All",
    [RecordingSessionStages.ACTIVE]: "In Progress",
    [RecordingSessionStages.COMPLETED]: "Completed",
    [RecordingSessionStages.PENDING]: "Pending",
    [RecordingSessionStages.REFUNDED]: "Refunded",
    [RecordingSessionStages.UPCOMING]: "Upcoming",
    [RecordingSessionStages.SESSION_MODIFICATION]: "Modification Pending",
  };
